import React from 'react';
import PropTypes from 'prop-types';
import { Image, Paragraph } from 'components';
import './Perk.scss';

const Perk = ({ icon, title, text }) => (
  <div className={'perk__container'}>
    <div className={'perk__icon'}>
      <Image src={icon} alt={title} />
    </div>
    <Paragraph size={'small'} additionalClass={'perk__text'}>
      <strong>{title}</strong>
      {text}
    </Paragraph>
  </div>
);

Perk.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
};

export default Perk;
